(function () {
  function arrange(root) {
    if (root.dataset.arranged) return;
    root.dataset.arranged = 'true';
    const description = root.querySelector('[data-cjs-description]');
    const target = root.querySelector('[data-cjs-description-specs]');
    description.querySelectorAll('table').forEach(table => {
      Array.from(table.rows).forEach(row => {
        if (row.cells.length === 1 && /^notes?\s*:?$/i.test(row.textContent.trim()) && !row.querySelector('img,a,input')) row.remove();
      });
      const rows = Array.from(table.rows);
      if (!rows.length || !rows.every(row => row.cells.length === 2 && Array.from(row.cells).every(cell => cell.colSpan === 1 && cell.rowSpan === 1))) return;
      rows.forEach(row => { if (!row.cells[1].textContent.trim() && !row.cells[1].querySelector('img,a,input')) row.remove(); });
      if (table.rows.length) target.append(table);
    });
    const hasOverview = description.textContent.trim() || description.querySelector('img,video,iframe,table,ul,ol');
    if (!hasOverview) {
      description.hidden = true;
      root.querySelector('.cjs-integrated-details__overview > h2').hidden = true;
    }
    const specs = root.querySelector('[data-cjs-technical]');
    const hasSpecs = specs.querySelector('table,.cjs-product-main__spec-row');
    if (!hasSpecs) {
      specs.hidden = true;
      root.querySelector('[data-cjs-spec-link]').hidden = true;
      root.classList.add('cjs-integrated-details--single');
    }
  }
  function init(container) { container.querySelectorAll('[data-cjs-integrated-details]').forEach(arrange); }
  init(document);
  if (!window.cjsIntegratedDetailsBound) {
    window.cjsIntegratedDetailsBound = true;
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})();
